export default __webpack_public_path__ + "static/media/logo-mobile.cdccc67a.svg";